import { useState } from "react";
import styles from "../NewsletterTable/NewsLetterTable.module.scss";
import ActiveIcon from "../../../assets/icons/ActiveIcon";
import BlockedIcon from "../../../assets/icons/BlockedIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import TelegramIcon from "../../../assets/icons/TelegramIcon";
import CustomTable from "../CustomTable/CustomTable";

const PaymentsTable = () => {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const columns = [
    {
      title: "Период",
      dataIndex: "date",
      key: "date",
      align: "center",
    },
    {
      title: "Тариф",
      dataIndex: "package",
      key: "package",
      align: "center",
    },
    {
      title: "Разрешено",
      dataIndex: "allowed",
      key: "allowed",
      align: "center",
    },
    {
      title: "Использовано",
      dataIndex: "used",
      key: "used",
      align: "center",
    },
    {
      title: "Осталось",
      dataIndex: "remaining",
      key: "remaining",
      align: "center",
    },
    {
      title: "Свыше тарифа",
      dataIndex: "above",
      key: "above",
      align: "center",
    },
  ];

  const mockData = Array.from({ length: 12 }, (_, i) => ({
    key: i,
    date: "01.01.2021 - 01.02.2021",
    package: "Тариф 1",
    allowed: "1000",
    used: "500",
    remaining: "500",
    above: "0",
  }));

  return <CustomTable columns={columns} mockData={mockData} />;
};

export default PaymentsTable;
